import * as React from "react";

export const HistoryIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#23252A",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    color={color}
    viewBox="0 0 20 20"
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M2.5 10A7.5 7.5 0 1 0 10 2.5a8.13 8.13 0 0 0-5.617 2.283L2.5 6.667"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M2.5 2.5v4.167h4.167M10 5.833V10l3.333 1.667"
    ></path>
  </svg>
);
